.modal {
    max-width: 756px;
  }
  
  .title {
    font-size: var(--fs-heading);
    font-weight: 600;
    margin: 0 0 0.5rem 0;
    color: var(--static-text-strong);
  }

  .modalHeader {
    padding: 2rem 2.5rem 0 2.5rem;
  }
  
  .modalBody {
    padding: 0 2.5rem;
  }
  
  .subtitle {
    margin: 0;
    color: var(--static-text-standard);
    font-size: var(--fs-normal);
    font-weight: 400;
  }
  
  .alert {
    margin: 1.5rem 0 1.5rem 0;
  }
  
  .feedbackIntro {
    margin: 0 0 1.5rem 0;
    color: var(--static-text-standard);
    font-size: var(--fs-normal);
  }
  
  .formGroup {
    /* display: flex; */
    margin-bottom: 1.5rem;
  }
  
  .label {
    display: block;
    /* margin-bottom: 0.5rem; */
    /* font-weight: 500; */
    font-weight: 400;
    color: var(--static-text-standard);
  }
  
  .select {
    width: 100%;
  }
  
  .textarea {
    width: 100%;
    min-height: 120px;
    resize: vertical;
  }
  
  .charCount {
    text-align: right;
    font-size: var(--fs-small);
    color: var(--static-text-weak);
  }
  
  .error {
    color: var(--sentiment-text-negative);
    margin-bottom: 1rem;
    font-size: var(--fs-small);
  }
  
  .supportNote {
    margin: 1.5rem 0 1.5rem 0;
    font-size: var(--fs-small);
    color: var(--static-text-weak);
  }
  
  .supportLink {
    color: var(--primary-enabled);
    text-decoration: none;
    font-weight: 500;
  }
  
  .supportLink:hover {
    text-decoration: underline;
  }
  
  .footer {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }